import { createContext } from "react";

export interface ActiivityContentProps {
  shareCode: string;
  userStatus: number;
}

// Create a context
const ActivityContext = createContext<ActiivityContentProps | undefined>(
  undefined
);

export default ActivityContext;
